import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ConsoleI18nProvider } from './lib/locale'
import { routeTree } from './routeTree.gen'
import './styles.css'

/**
 * Entry point. The router is created once and the whole tree sits inside the locale provider, so
 * every route and every shared component reads the same language (ADR 0010).
 */
const router = createRouter({ routeTree, defaultPreload: 'intent' })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const container = document.getElementById('root')
if (container === null) throw new Error('Missing #root in index.html')

createRoot(container).render(
  <StrictMode>
    <ConsoleI18nProvider>
      <RouterProvider router={router} />
    </ConsoleI18nProvider>
  </StrictMode>,
)
